import { TournamentState } from '@ps/web-poker-tile-mappers';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { usePokerSundayMillionWidget } from '../model';

import useFormatDateBySeconds from './useFormatDateBySeconds';
import {
  TXTCLI_Ended_on_N0,
  TXTCLI_Join_us_on_N0_for_the_next_Xsp_ELL,
  TXTCLI_Late_Registration_ends_in_8,
  TXTCLI_Running_for,
  TXTCLI_Starts_In,
  TXTCLI_Stay_tuned_so_you_donXt_miss_o_ELL,
  TXTCLI_This_tournament_has_been_cance_ELL,
  TXTCLI_This_tournament_is_temporarily_ELL,
  TXTCLI_this_is_a_N0_day_event
} from './useGetMessages.messages.json';

const useGetMessages = () => {
  const { formatMessage } = useIntl();
  const { widgetSelect } = usePokerSundayMillionWidget();

  const date = useSelector(widgetSelect.getTimerDate);
  const formattedDate = useFormatDateBySeconds(date);
  const tournament = useSelector(widgetSelect.getTournament);
  const {
    nextWhenStartInt: next,
    tournNumDays: numDays = 2,
    formattedState: state
  } = tournament || {
    nextWhenStartInt: undefined,
    tournNumDays: undefined,
    formattedState: undefined
  };
  const formattedNext = useFormatDateBySeconds(next);
  let line1, line2, line1Alt;

  const nextMessage = next
    ? formatMessage(TXTCLI_Join_us_on_N0_for_the_next_Xsp_ELL, {
        0: <span data-event-date={formattedNext}>{formattedNext}</span>,
        span: (value) => <span data-event-name="sunday-million">{value}</span>
      })
    : formatMessage(TXTCLI_Stay_tuned_so_you_donXt_miss_o_ELL);

  switch (state) {
    case TournamentState.ANNOUNCED:
    case TournamentState.REGISTERING:
    case TournamentState.SEATING: {
      line1 = numDays
        ? `${formattedDate} (${formatMessage(TXTCLI_this_is_a_N0_day_event, {
            0: numDays
          })})`
        : formattedDate; // POKER-13543
      line1Alt = `${formattedDate} ${formatMessage(TXTCLI_Starts_In)}`;
      line2 = formatMessage(TXTCLI_Starts_In);
      break;
    }
    case TournamentState.RUNNING: {
      line1 = formatMessage(TXTCLI_Running_for);
      line1Alt = formatMessage(TXTCLI_Running_for);
      line2 = nextMessage;
      break;
    }
    case TournamentState.LATE_REGISTRATION: {
      line1 = formatMessage(TXTCLI_Running_for);
      line1Alt = formatMessage(TXTCLI_Late_Registration_ends_in_8);
      line2 = formatMessage(TXTCLI_Late_Registration_ends_in_8);
      break;
    }
    case TournamentState.PAUSED: {
      line1 = formatMessage(TXTCLI_This_tournament_is_temporarily_ELL);
      line1Alt = formatMessage(TXTCLI_This_tournament_is_temporarily_ELL);
      line2 = nextMessage;
      break;
    }
    case TournamentState.COMPLETED: {
      line1 = formatMessage(TXTCLI_Ended_on_N0, { 0: formattedDate });
      line1Alt = formatMessage(TXTCLI_Ended_on_N0, { 0: formattedDate });
      line2 = nextMessage;
      break;
    }
    case TournamentState.CANCELLED: {
      line1 = formatMessage(TXTCLI_This_tournament_has_been_cance_ELL);
      line1Alt = formatMessage(TXTCLI_This_tournament_has_been_cance_ELL);
      line2 = nextMessage;
      break;
    }
    default: {
      line1 = nextMessage;
      line1Alt = nextMessage;
    }
  }

  return { line1, line1Alt, line2 };
};

export default useGetMessages;
